import React, { useState, useEffect } from 'react';
import styles from './ColorInput.module.scss';

const ColorInput = ({
  label,
  value,
  onChange,
  style,
  name = '',
  initialColor = '#000000',
  error,
  touched,
}) => {
  const [inputValue, setInputValue] = useState(value || initialColor);
  const [timer, setTimer] = useState(null);

  const isValidHex = (color) => {
    return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(color);
  };

  const expandShortHex = (hex) => {
    if (hex.length === 4) {
      return '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3] + 'ff';
    } else if (hex.length === 5) {
      return (
        '#' +
        hex[1] +
        hex[1] +
        hex[2] +
        hex[2] +
        hex[3] +
        hex[3] +
        hex[4] +
        hex[4]
      );
    }
    return hex;
  };

  const handleTextInputChange = (e) => {
    const newValue = e.target.value;
    if (newValue.length > 9) return;
    setInputValue(newValue);

    if (timer) clearTimeout(timer);

    setTimer(
      setTimeout(() => {
        onChange && onChange({ target: { name, value: newValue } });
      }, 500)
    );
  };

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  const hexWithoutAlpha = inputValue.substring(0, 7);
  const alpha =
    inputValue.length === 9
      ? parseInt(inputValue.substring(7, 9), 16) / 255
      : 1;

  return (
    <div className={`${styles['input-container']}`} style={style}>
      {label && (
        <label className={`${styles['color-input__label']}`}>{label}</label>
      )}

      <div
        className={`${styles['color-input']} ${
          error && touched ? styles.error : ''
        }`}
      >
        <div className={styles['input-wrapper']}>
          <input
            type="color"
            name={name}
            value={hexWithoutAlpha}
            onChange={(e) => {
              const selectedColor = e.target.value;
              const newColor =
                selectedColor +
                (inputValue.length === 9 ? inputValue.substring(7, 9) : 'ff');
              setInputValue(newColor);
              onChange && onChange({ target: { name, value: newColor } });
            }}
            className={styles['color-picker']}
          />
          <div
            className={styles['color-preview']}
            style={{ backgroundColor: hexWithoutAlpha, opacity: alpha }}
          ></div>
        </div>

        <input
          type="text"
          value={inputValue || ''}
          onChange={handleTextInputChange}
          placeholder="Enter a color"
          className={styles['color-picker-input-text']}
        />
      </div>
    </div>
  );
};

export default ColorInput;
